<template>
  <div class="col-span-12 lg:col-span-8">
    <router-view />
  </div>
</template>
